
// FILTER KEYS
export const filterKeys = {
  SELECTED_STORES: 'shopIds',
  SELECTED_STATUSES: 'statuses',
  DATE_FROM: 'createdDateFrom',
  DATE_TO: 'createdDateTo',
  SEARCH_TEXT: 'search'
}
